import { GradientBlobs } from "./GradientBlobs";
import { Reveal } from "./Reveal";
import { SectionLabel } from "./SectionHeading";
import { ScrollColorHeading } from "./ScrollColorHeading";

// Reusable inner-page hero — main heading changes colour with page movement
export const PageHero = ({ label, titleLines = [], intro, align = "left" }) => (
  <section className="relative overflow-hidden bg-white noise-overlay pt-40 md:pt-52 pb-20 md:pb-28" data-testid="page-hero">
    <GradientBlobs />
    <div className={`relative z-10 max-w-[1400px] mx-auto px-6 md:px-12 ${align === "center" ? "text-center" : ""}`}>
      {label && (
        <Reveal>
          <div className={align === "center" ? "flex justify-center" : ""}><SectionLabel>{label}</SectionLabel></div>
        </Reveal>
      )}
      <ScrollColorHeading
        lines={titleLines}
        testId="page-hero-title"
        className="mt-6 font-heading font-extrabold text-5xl md:text-7xl lg:text-8xl leading-[0.98] tracking-tight"
      />
      {intro && (
        <Reveal delay={0.3}>
          <p className={`mt-8 text-brand-ink/75 text-lg md:text-xl leading-relaxed max-w-2xl ${align === "center" ? "mx-auto" : ""}`}>{intro}</p>
        </Reveal>
      )}
    </div>
  </section>
);
